
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 56 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M15.75 17.5A1.751 1.751 0 0114 15.75v-14a1.75 1.75 0 013.5 0v14a1.751 1.751 0 01-1.75 1.75z"}}),_c('path',{staticClass:"a",attrs:{"d":"M22.75 10.5a1.741 1.741 0 01-1.237-.513L15.75 4.225 9.987 9.987a1.749 1.749 0 01-2.474-2.474l7-7a1.748 1.748 0 012.474 0l7 7A1.75 1.75 0 0122.75 10.5zm17.5 7a1.75 1.75 0 01-1.75-1.75v-14a1.75 1.75 0 013.5 0v14a1.75 1.75 0 01-1.75 1.75z"}}),_c('path',{staticClass:"a",attrs:{"d":"M40.25 17.5a1.741 1.741 0 01-1.237-.513l-7-7a1.749 1.749 0 012.474-2.474l5.763 5.762 5.763-5.762a1.749 1.749 0 012.474 2.474l-7 7a1.741 1.741 0 01-1.237.513zm14 38.5H1.75A1.75 1.75 0 010 54.25v-31.5A1.751 1.751 0 011.75 21h52.5A1.75 1.75 0 0156 22.75v31.5A1.749 1.749 0 0154.25 56zM3.5 52.5h49v-28h-49z"}}),_c('path',{staticClass:"a",attrs:{"d":"M17.5 42a7 7 0 117-7 7.008 7.008 0 01-7 7zm0-10.5A3.5 3.5 0 1021 35a3.5 3.5 0 00-3.5-3.5z"}}),_c('path',{staticClass:"a",attrs:{"d":"M26.25 56H8.75A1.75 1.75 0 017 54.25V52.5a10.5 10.5 0 0121 0v1.75A1.75 1.75 0 0126.25 56zM10.5 52.5h14a7 7 0 00-14 0zm28-10.5a7 7 0 117-7 7.009 7.009 0 01-7 7zm0-10.5A3.5 3.5 0 1042 35a3.5 3.5 0 00-3.5-3.5z"}}),_c('path',{staticClass:"a",attrs:{"d":"M47.25 56h-17.5A1.75 1.75 0 0128 54.25V52.5a10.5 10.5 0 0121 0v1.75A1.749 1.749 0 0147.25 56zM31.5 52.5h14a7 7 0 00-14 0z"}})])
          )
        }
      }
    